const template = require('./index.html')
const domValue = require('dom-value')

//Components
const makeItInputComponent = require('@isoftdata/input')
const makeItButtonComponent = require('@isoftdata/button')
const makeItMapButton = require('@isoftdata/map-button')

module.exports = function createAddressCardComponent() {
	return Ractive.extend({
		template,
		components: {
			itInput: makeItInputComponent({ twoway: true, lazy: true }),
			itButton: makeItButtonComponent(),
			itMapButton: makeItMapButton(),
		},
		transitions: {
			slide: require('ractive-transitions-slide'),
		},
		data() {
			return {
				domValue,
				title: 'Address',
				editMode: false,
				editModeButtonShown: true,
				editModeButtonDisabled: false,
				showMapButton: true,
				titleIcon: 'fas fa-address-card',
				cardClass: '',
				company: '',
				contact: '',
				street: '',
				mailing: '',
				city: '',
				state: '',
				zip: '',
				country: '',
				phone: '',
			}
		},
		computed: {
			cityStateZip() {
				const city = this.get('city')
				const state = this.get('state')

				const address = [
					city && state ? `${city},` : city,
					state,
					this.get('zip'),
				]

				return address.filter(part => part).join(' ')
			},
		},
		oninit() {
			const ractive = this

			ractive.on('toggleEditMode', () => {
				ractive.toggle('editMode').then(() => {
					if (ractive.get('editMode')) {
						const companyInput = ractive.find('#companyInput')
						if (companyInput) {
							companyInput.select()
						}
					}
				})
			})
		},
	})
}
